@let block = copyright();

@if (block.styles) {
    <div [appCmsStyles]="block.styles"></div>
}
@if (block.content) {
    <div
        class="footer-copyright__notice tg-caption cms-content"
        [innerHtml]="block.content | trustHtml"
    ></div>
}
